import React, { useContext } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// assets
import defaultMemberIcon from "bodycodi/cmap/app/img/icon_defailt.png";
import icon_more24 from "bodycodi/cmap/app/svg/icon_more24.svg";

// utils
import { isEmpty, formatCommentDate } from "bodycodi/cmap/app/js/common";

const Comment = ({ comment, setSelectedComment }: any) => {
  const { dispatch } = useContext(DispatchContext);

  const formattedDate = formatCommentDate(comment.regDts).timeText || "";
  const formattedName = `${comment.name ? comment.name : ""}  ${
    comment.partnerName ? " · " + comment.partnerName : ""
  }`;

  const openCommentDrawer = () => {
    setSelectedComment(comment);
    dispatch({ type: "POP_UP_OPEN", id: "COMMENT_CONFIRM_POP", open: { commentConfirmPop: open } });
  };

  return (
    <div className="commnet-wrap">
      <div className="profile">
        <img
          className="profile-line"
          src={isEmpty(comment.imgUrl) ? defaultMemberIcon : comment.imgUrl}
        />
      </div>
      <div className="info">
        <div className="name-box">
          <div className="name">{formattedName}</div>
          {comment.cmntPagCd === "C" && <img src={icon_more24} onClick={openCommentDrawer} />}
        </div>
        <div className="commnet">{comment?.cmntCtnt}</div>
        <div className="date" dangerouslySetInnerHTML={{ __html: formattedDate }} />
      </div>
    </div>
  );
};

export default Comment;
